<template>
    <div id="interview_member">
        <HrrBreadcrumb PMname="其他功能" CMname="设备版本管理" C2Mname="绑定设备管理" />
        <HrrMainCardLayout>
            <template slot="custom">
                <el-form label-position="right" inline class="lightbox-from" label-width="100px">
                    <el-form-item label="版本序号：">
                        <span>{{adform.dVersionId}}</span>
                    </el-form-item>
                    <el-form-item label="版本编号：">
                        <span>{{adform.version}}</span>
                    </el-form-item>
                    <el-form-item label="版本描述：">
                        <span>{{adform.versionDesc}}</span>
                    </el-form-item>
                </el-form>
            </template>
        </HrrMainCardLayout>
        <h3>已绑定设备列表</h3>
        <HrrMainLayout :nobuttons="false">
            <template slot="searh">
                <el-form :inline="true" :model="mform">
                    <el-form-item label="站点名称：">
                        <el-select v-model="mform.siteId" @change="mChangeSiteId" placeholder="请选择" filterable>
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in siteidData" :key="item.SiteId" :label="item.SiteName" :value="item.SiteId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="媒体名称：">
                        <el-select v-model="mform.lightBoxId" placeholder="请选择" filterable>
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in mAdLightBox" :key="item.lightBoxId +'-'+item.deviceId" :label="item.lightBoxName" :value="item.lightBoxId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="keyword" placeholder="关键字">
                            <el-select v-model="selectfield" slot="prepend" placeholder="请选择" class="input-with-select">
                                <el-option label="设备编号" value="deviceNickCode"></el-option>
                                <el-option label="设备名称" value="deviceName"></el-option>
                            </el-select>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                        <el-button type="info" icon="el-icon-back" @click="returnForm">返回</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button-group>
                    <el-button type="primary" icon="fa fa-cubes" size="small" @click="Sendorderallclick()">下发所有设备指令</el-button>
                </el-button-group>
            </template>
            <template slot="table">
                <el-table :data="membertable" ref="membertable" border stripe highlight-current-row v-loading="mloading" style="width: 100%; margin-top: 20px;">
                    <el-table-column prop="deviceId" label="设备ID" width="140" fixed="left">
                    </el-table-column>
                    <el-table-column prop="deviceNickCode" label="设备编号" width="140" fixed="left">
                    </el-table-column>
                    <el-table-column prop="deviceCode" label="自动设备编号" width="140" v-if="isHadFun('deviceCode')" fixed="left">
                    </el-table-column>
                    <el-table-column prop="deviceName" label="设备名称" >
                    </el-table-column>
                    <el-table-column prop="deviceVersion" label="软件版本" width="180" fixed="left">
                    </el-table-column>
                    <el-table-column prop="lightBoxCode" label="所在媒体编号">
                    </el-table-column>
                    <el-table-column prop="siteName" label="所属站点">
                    </el-table-column>
                    <el-table-column label="状态" width="100" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-tag type="danger" disable-transitions v-if="scope.row.status==0">待更新</el-tag>
                            <el-tag type="info" disable-transitions v-if="scope.row.status==1">指令发出</el-tag>
                            <el-tag type="primary" disable-transitions v-if="scope.row.status==2">完成</el-tag>
                            <el-tag type="success" disable-transitions v-if="scope.row.status==-1">更新失败</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="200" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click.stop="SendorderData(scope.row)" type="text" size="small">下发指令</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="mhandleSizeChange" @current-change="mhandleCurrentChange" :current-page="mform.pageNum" :page-sizes="[5, 10, 15,50]" layout="total, sizes, prev, pager, next, jumper" :total="mtotal">
                </el-pagination>
            </template>
        </HrrMainLayout>
        <h3>待绑定设备</h3>
        <HrrMainLayout>
            <template slot="searh">
                <el-form :inline="true" :model="uform">
                    <el-form-item label="站点名称：">
                        <el-select v-model="uform.siteId" @change="changeSiteId" placeholder="请选择" filterable>
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in siteidData" :key="item.SiteId" :label="item.SiteName" :value="item.SiteId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="媒体名称：">
                        <el-select v-model="uform.lightBoxId" placeholder="请选择" filterable>
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in adLightBox" :key="item.lightBoxId +'-'+item.deviceId" :label="item.lightBoxName" :value="item.lightBoxId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="ukeyword" placeholder="关键字">
                            <el-select v-model="uselectfield" slot="prepend" placeholder="请选择" class="input-with-select">
                                <el-option label="设备编号" value="deviceNickCode"></el-option>
                                <el-option label="设备名称" value="deviceName"></el-option>
                            </el-select>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onuSubmit">查 询</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button-group>
                    <el-button type="primary" icon="fa fa-cubes" size="small" @click="addDeviceAllclick()">批量绑定设备</el-button>
                    <el-button type="primary" icon="el-icon-finished" size="small" @click="postAllDeviceclick()">绑定所有设备</el-button>
                </el-button-group>
            </template>
            <template slot="table">
                <el-table :data="uData" ref="utable" border stripe highlight-current-row v-loading="uloading" style="width: 100%" @cell-click="cellclick" @selection-change="selectionchange">
                    <el-table-column type="selection" width="55" fixed="left">
                    </el-table-column>
                    <el-table-column prop="deviceId" label="设备ID" width="140" fixed="left">
                    </el-table-column>
                    <el-table-column prop="deviceNickCode" label="设备编号" width="140" fixed="left">
                    </el-table-column>
                    <el-table-column prop="deviceCode" label="自动设备编号" width="140" v-if="isHadFun('deviceCode')" fixed="left">
                    </el-table-column>
                    <el-table-column prop="deviceName" label="设备名称" width="180" >
                    </el-table-column>
                    <el-table-column prop="lightBoxCode" label="所在媒体编号">
                    </el-table-column>
                    <el-table-column prop="siteName" label="所属站点">
                    </el-table-column>
                    <el-table-column label="操作" width="100" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click.stop="BindingDevice(scope.row)" type="text" size="small">绑定设备</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="uhandleSizeChange" @current-change="uhandleCurrentChange" :current-page="uform.pageNum" :page-sizes="[5, 10, 15,50]" layout="total, sizes, prev, pager, next, jumper" :total="utotal">
                </el-pagination>
            </template>
        </HrrMainLayout>
    </div>
</template>
<script>
export default {
    name: 'Device_Binddevice',
    data() {
        return {
            mform: {
                pageNum: 1,
                pageSize: 10,
                dVersionId: this.$route.meta.row.dVersionId,
                deviceId: "",
                deviceName: "",
                deviceNickCode: "",
                siteName: "",
                siteId: "",
                lightBoxId: "",
            },
            uform: {
                pageNum: 1,
                pageSize: 10,
                dVersionId: this.$route.meta.row.dVersionId,
                deviceId: "",
                deviceName: "",
                deviceNickCode: "",
                siteName: "",
                siteId: "",
                lightBoxId: "",
            },
            adform: {
                dVersionId: this.$route.meta.row.dVersionId,
                version: this.$route.meta.row.version,
                versionDesc: this.$route.meta.row.versionDesc
            },
            mkeyword: "",
            siteidData: [],
            mAdLightBox: [],
            adLightBox: [],
            adLightBoxDefault: 0,
            mAdLightBoxDefault: 0,
            dialogVisible: false,
            cardDialogVisible: false,
            BindCardAdid: "",
            state: "",
            cardFront: "",
            cardBehind: "",
            deviceId: "",


            membertable: [],
            uData: [],
            mtotal: 0,
            utotal: 0,
            mloading: false,
            uloading: false,
            selectionRows: [],
            cardselectionRows: [],
            showInterviewDesc: "",
            keyword: "",
            ukeyword: "",
            selectfield: "deviceNickCode",
            uselectfield: "deviceNickCode",
        }
    },
    methods: {
        onSubmit() {
            this.mform.deviceName = "";
            this.mform.deviceNickCode = "";
            this.mform.pageNum = 1;
            this.mform[this.selectfield] = this.keyword.trim();
            this.initData();
        },
        onuSubmit() {
            this.uform.deviceName = "";
            this.uform.deviceNickCode = "";
            this.uform.pageNum = 1;
            this.uform[this.uselectfield] = this.ukeyword.trim();
            this.initunselectData();
        },
        returnForm() {
            this.$router.go(-1);
        },
        mhandleSizeChange(val) {
            this.mform.pageSize = val;
            this.initData();
        },
        mhandleCurrentChange(val) {
            this.mform.pageNum = val;
            this.initData();
        },
        uhandleSizeChange(val) {
            this.uform.pageSize = val;
            this.initunselectData();
        },
        uhandleCurrentChange(val) {
            this.uform.pageNum = val;
            this.initunselectData();
        },
        BindingDevice(val) {
            this.$confirm("确定要绑定  设备号：'" + val.deviceNickCode + "',设备名称：'" + val.deviceName + "' 此记录么？", "绑定提示", { type: "warning" })
                .then(() => {
                    var Vuethis = this;
                    this.$hrraxios.post(this.$api.Version.binddevice, { dVersionId: this.$route.meta.row.dVersionId, deviceId: val.deviceId })
                        .then((response) => {
                            var redata = response.data;
                            if (redata.Success == true) {
                                Vuethis.$message({ message: "绑定成功！", type: "success" });
                                Vuethis.initData();
                                Vuethis.initunselectData();
                            } else {
                                Vuethis.$message({ message: redata.Prompt, type: "error" });
                            }
                        })
                }).catch((error) => {
                    console.log(error);
                });
        },
        cellclick(row, column, cell, event) {
            this.$refs.utable.toggleRowSelection(row);
        },
        selectionchange(selection) {
            this.selectionRows = selection;
        },
        addDeviceAllclick() {
            if (this.selectionRows.length < 1) {
                this.$message({ message: "请先选择一行在绑定", type: "warning" });
                return;
            }
            this.$confirm("确定要绑定这些记录么？", { type: "warning" })
                .then(() => {
                    var loading = this.$loading({
                        lock: true,
                        text: '绑定中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var PostfunArr = [];
                    this.selectionRows.forEach(myrow => {
                        var postRe = this.$hrraxios.post(this.$api.Version.binddevice, { dVersionId: this.$route.meta.row.dVersionId, deviceId: myrow.deviceId })

                        PostfunArr.push(postRe);
                    });
                    this.$axios.all(PostfunArr)
                        .then(this.$axios.spread(function() {
                            loading.close();
                            //console.log(arguments);
                            var isalldel = true;
                            for (var i = 0; i < arguments.length; i++) {
                                if (arguments[i].data.Success == false) {
                                    isalldel = false;
                                }
                            }
                            if (isalldel == true) {
                                Vuethis.$message({ message: "全部绑定成功！", type: "success" });
                                Vuethis.initData();
                                Vuethis.initunselectData();
                            } else {
                                //有删除失败的未处理
                            }
                        }));
                })
                .catch((error) => {
                    loading.close();

                });
        },
        postAllDeviceclick() {
            this.$confirm("确定要绑定所有设备么？", { type: "warning" })
                .then(() => {
                    var loading = this.$loading({
                        lock: true,
                        text: '绑定中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    this.$hrraxios.get(this.$api.Version.postall + "/" + this.$route.meta.row.dVersionId)
                        .then((response) => {
                            var redata = response.data;
                            loading.close();
                            if (redata.Success == true) {
                                Vuethis.$message({ message: "绑定成功！", type: "success" });
                                Vuethis.initData();
                                Vuethis.initunselectData();
                            } else {
                                Vuethis.$message({ message: redata.Prompt, type: "error" });
                            }
                        })
                }).catch((error) => {
                    loading.close();
                    console.log(error);
                });
        },
        Sendorderallclick() {
            this.$confirm("确定要对所有设备下发指令么？", { type: "warning" })
                .then(() => {
                    var loading = this.$loading({
                        lock: true,
                        text: '下发指令中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    this.$hrraxios.get(this.$api.Version.sendorderall + "/" + this.$route.meta.row.dVersionId)
                        .then((response) => {
                            loading.close();
                            var redata = response.data;
                            if (redata.Success == true) {
                                Vuethis.$message({ message: "下发指令成功！", type: "success" });
                                Vuethis.initData();
                                Vuethis.initunselectData();
                            } else {
                                loading.close();
                                Vuethis.$message({ message: redata.Prompt, type: "error" });
                            }
                        })
                }).catch((error) => {
                    loading.close();
                    console.log(error);
                });
        },
        SendorderData(val) {
            this.$confirm("确定要对  设备号：'" + val.deviceNickCode + "',设备名称：'" + val.deviceName + "' 下发指令么？", "下发指令提示", { type: "warning" })
                .then(() => {
                    var Vuethis = this;
                    this.$hrraxios.get(this.$api.Version.sendorder + "/" + val.dvrId)
                        .then((response) => {
                            var redata = response.data;
                            if (redata.Success == true) {
                                Vuethis.$message({ message: "下发指令成功！", type: "success" });
                                Vuethis.initData();
                                Vuethis.initunselectData();
                            } else {
                                Vuethis.$message({ message: redata.Prompt, type: "error" });
                            }
                        })
                }).catch((error) => {
                    console.log(error);
                });
        },
        changeSiteId(val) {
            if (val == "") {
                this.adLightBoxDefault = 0
            } else {
                this.adLightBoxDefault = val
            }
            this.uform.lightBoxId = "";
            this.adLightBoxData();
        },
        mChangeSiteId(val) {
            if (val == "") {
                this.mAdLightBoxDefault = 0
            } else {
                this.mAdLightBoxDefault = val
            }
            this.mform.lightBoxId = "";
            this.mAdLightBoxData();
        },
        initData() {
            var Vuethis = this;
            this.mloading = true;
            this.$hrraxios.get(this.$api.Version.select, { params: this.mform })
                .then(function(response) {
                    Vuethis.mloading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.membertable = data.Data.List;
                        Vuethis.mtotal = data.Data.Total;
                    } else {
                        Vuethis.$message.error(data.prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.mloading = false;
                    console.log(error);
                });
        },
        initunselectData() {
            var Vuethis = this;
            this.uloading = true;
            this.$hrraxios.get(this.$api.Version.unselected, { params: this.uform })
                .then(function(response) {
                    Vuethis.uloading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.uData = data.Data.List;
                        Vuethis.utotal = data.Data.Total;
                    } else {
                        Vuethis.$message.error(data.prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.uloading = false;
                    console.log(error);
                });
        },
        initParamsData() {
            var Vuethis = this;
            this.$hrraxios.get(this.$api.site.downlist)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.siteidData = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        adLightBoxData() {
            var Vuethis = this;
            this.$hrraxios.get(this.$api.device.getNoDevice + "/" + this.adLightBoxDefault)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.adLightBox = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        mAdLightBoxData() {
            var Vuethis = this;
            this.$hrraxios.get(this.$api.device.getNoDevice + "/" + this.mAdLightBoxDefault)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.mAdLightBox = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
    },
    created() {
        this.$common.getFunListByMCode(this, "DeviceVersion", () => {
            this.initData();
            this.initParamsData();
            this.adLightBoxData();
            this.mAdLightBoxData();
            this.initunselectData();
        });
    }
}
</script>
<style>
#adData {
    position: absolute;
    margin-left: 20px;
    margin-top: 7px;
    color: #606266;
}

#interview_member h3 {
    margin-left: 15px;
}

#interview_member .heightshow {
    color: red;
    font-weight: bold;
}

#interview_member .lightbox-from .el-form-item__label {
    font-size: 16px !important;
    font-weight: bold;
    color: #4a65fb;
}

#interview_member .lightbox-from .el-form-item__content {
    font-size: 16px !important;
}

#interview_member .lightbox-from .el-form-item {
    margin-bottom: 0;
}
.el-tag-written-m {
    margin-left: 6px;
}

.el-select-room {
    width: 300px;
}
</style>